export default __webpack_public_path__ + "static/media/pay respects 12.f92b71d4.png";